// src/components/mindworkout/sections/WorkoutHeroSection.js
import React from 'react';
import styled from 'styled-components';
// eslint-disable-next-line no-unused-vars
import PhoneMockup from '../../ui/PhoneMockup';
import DownloadButton from '../../ui/DownloadButton';

const HeroContainer = styled.section`
    min-height: 100vh;
    background: linear-gradient(135deg, #FF6B6B 0%, #4ECDC4 100%);
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
`;

const ContentWrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
    align-items: center;
    
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        text-align: center;
    }
`;

const TextContent = styled.div`
    color: white;
`;

const Title = styled.h1`
    font-size: 3.5rem;
    font-weight: 800;
    margin-bottom: 1.5rem;
    line-height: 1.2;
    
    @media (max-width: 768px) {
        font-size: 2.5rem;
    }
`;

const Subtitle = styled.p`
    font-size: 1.5rem;
    margin-bottom: 2rem;
    opacity: 0.95;
`;

const Description = styled.p`
    font-size: 1.1rem;
    margin-bottom: 3rem;
    line-height: 1.6;
    opacity: 0.9;
`;

const ButtonGroup = styled.div`
    display: flex;
    gap: 1rem;
    
    @media (max-width: 768px) {
        justify-content: center;
        flex-wrap: wrap;
    }
`;

const Badge = styled.div`
    display: inline-block;
    background: rgba(255, 255, 255, 0.2);
    padding: 0.5rem 1rem;
    border-radius: 30px;
    font-size: 0.9rem;
    margin-bottom: 1rem;
`;

const WorkoutHeroSection = () => {
    return (
        <HeroContainer>
            <ContentWrapper>
                <TextContent>
                    <Badge>🚀 과학적으로 검증된 정신력 훈련</Badge>
                    <Title>마음의 근육을<br/>게임처럼 키우세요</Title>
                    <Subtitle>Mind Workout</Subtitle>
                    <Description>
                        집중력, 인내력, 감정조절, 공감력을 체계적으로 훈련하세요.<br/>
                        하루 10분, 당신의 정신력이 강해집니다.
                    </Description>
                    <ButtonGroup>
                        <DownloadButton platform="ios"/>
                        <DownloadButton platform="android"/>
                    </ButtonGroup>
                </TextContent>

                <div className="relative w-full flex justify-center lg:justify-end">
                    {/* 메인 폰 목업 - 원본 비율 유지 */}
                    <img
                        src="/images/workout/mindworkout-main-screen.jpg"  // 경로 수정
                        alt="Mind Workout 메인 화면"
                        style={{width: '70%', height: '50%'}}
                    />
                </div>
            </ContentWrapper>
        </HeroContainer>
    );
};

export default WorkoutHeroSection;
